export const Units_fa = {
    bytes: 'بایت',
    kb: 'کیلوبایت',
    mb: 'مگابایت',
    gb: 'گیگابایت',
    tb: 'ترابایت',
    pb: 'پتابایت',

    seconds_n: ':n ثانیه',
    minutes_n: ':n دقیقه',
    hours_n: ':n ساعت',
    days_n: ':n روز',
    weeks_n: ':n هفته',

    week_1: 'شنبه',
    week_2: 'یکشنبه',
    week_3: 'دوشنبه',
    week_4: 'سه شنبه',
    week_5: 'چهارشنبه',
    week_6: 'پنج شنبه',
    week_7: 'جمعه',
    jalali_1: 'فروردین',
    jalali_2: 'اردیبهشت',
    jalali_3: 'خرداد',
    jalali_4: 'تیر',
    jalali_5: 'مرداد',
    jalali_6: 'شهریور',
    jalali_7: 'مهر',
    jalali_8: 'آبان',
    jalali_9: 'آذر',
    jalali_10: 'دی',
    jalali_11: 'بهمن',
    jalali_12: 'اسفند',


    currency_iran_rial: 'ریال ایران',
    currency_toman: 'تومان',
    currency_us_dollar: 'دلار آمریکا',
    currency_euro: 'یورو',
    currency_indian_rupee: 'روپیه هند',
    currency_pound: 'پوند',
    currency_franc: 'فرانک',
    currency_lira: 'لیره',
    currency_dinar: 'دینار',

    time_morning: 'صبح',
    time_noon: 'ظهر',
    time_evening: 'عصر',
    time_night: 'شب',
};